<template>
  <div>
    <AppPreloader v-if="!fetched || company.isFetching" />
    <template v-else>
      <div v-if="error">
        {{ error }}
      </div>
      <div v-else />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { candidateStatuses } from '@/enums';
import httpClient from '@/api';
import AppPreloader from '../components/AppPreloader.vue';

export default {
  name: 'CandidatePersonalLink',
  components: {
    AppPreloader,
  },
  metaInfo() {
    return {
      title: 'Huntica',
    };
  },
  props: {
    hashId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      fetched: false,
    };
  },
  computed: {
    ...mapState('candidate', {
      candidate: state => state.data.candidate,
      vacancy: state => state.data.vacancy,
    }),
    ...mapState('company', ['company', 'vacancies']),
  },
  async mounted() {
    await this.fetch();
  },
  created() {
    this.calculateHeight();
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async fetch() {
      try {
        const token = await this.$store.dispatch('candidate/loginByHashId', {
          hashId: this.hashId,
          vacancyId: null,
        });
        const candidate = await httpClient.get('candidates');
        await this.$store.dispatch('candidate/fetchData', {
          vacancyId: candidate.data.data.vacancyId,
          token,
        });
        await this.$store.dispatch('company/fetchCompany', this.vacancy.companyId);

        this.redirectCandidate();
      } catch (e) {
        if (e.name === 'ApiError') {
          if (e.code === 404) {
            return this.$router.push({ name: '404' });
          }

          if (e.code === 410) {
            await this.$router.push({
              name: 'vacancy',
              params: {
                companyId: e.data.companyId,
                vacancyId: e.data.vacancyId,
                hashId: this.hashId,
              },
            });
            return this.$toast.error(e.message, { timeout: 5000 });
          }
        }
        this.error = e.message;
      }
    },
    redirectCandidate() {
      if (this?.company?.data?.companyTemplateSettings) {
        window.location.href = `${process.env.VUE_APP_CAREER_PORTAL_URL}/${this.vacancy.companyId}/vacancies/${this.vacancy.id}/reply/${this.hashId}`;
        return;
      }

      if (this.candidate.status === candidateStatuses.IMPORTED && !this.candidate.interview) {
        localStorage.setItem('interviewStep', 2);
        return this.$router.push({
          name: 'interview',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            step: 2,
          },
        });
      }

      if (this.candidate.status === candidateStatuses.INTERVIEWED
        && this.candidate.interview) {
        return this.$router.push({
          name: 'interviewResult',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            hashId: this.hashId,
          },
        });
      }

      if (this.candidate.interview) {
        return this.$router.push({
          name: this.$route.meta.iframe ? 'iframeInterviewContinue' : 'interviewContinue',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            hashId: this.hashId,
          },
        });
      }
      return this.$router.push({
        name: this.$route.meta.iframe ? 'iframeVacancyReply' : 'vacancyReply',
        params: {
          companyId: this.vacancy.companyId,
          vacancyId: this.vacancy.id,
          hashId: this.hashId,
        },
      });
    },
    calculateHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.documentElement.scrollHeight;
          if (document.documentElement.offsetHeight > height) {
            height = document.documentElement.offsetHeight;
          }
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ height }, '*');
        }, 1000);
      });
    },
  },
};
</script>
